import Switch from './switch.vue';

Switch.install = function(Vue){
    Vue.component(Switch.name, Switch);
}

export default Switch;



// WEBPACK FOOTER //
// ./src/componnets/switch/index.js